(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('CreditPackageConfirmationDialogController', creditPackageConfirmationDialogController);

    function creditPackageConfirmationDialogController($mdDialog, $translate) {

        const vm = this;

        init();

        vm.confirm = function () {

            return $mdDialog.hide(true);
        };

        vm.close = function () {

            return $mdDialog.cancel();
        };

        vm.getConfirmTitleText = function () {
            return $translate.instant('Are you sure you want to {{action}} to the {{package}} package?', {
                action: vm.actionText || '',
                package: (vm.futurePlan && vm.futurePlan.name) || ''
            });
        };

        vm.getCreditsExtraText = function () {
            const amount = (vm.futurePlan && vm.futurePlan.amount !== null) ? vm.futurePlan.amount : '';
            return $translate.instant('After the change you will have {{amount}} monthly lead credits extra on top of the credits of your plan.', { amount });
        };

        vm.getCurrentCreditsText = function () {
            const amount = (vm.currentPlan && vm.currentPlan.amount !== null) ? vm.currentPlan.amount : '';
            return $translate.instant('Currently you have {{amount}} monthly lead credits extra.', { amount });
        };

        vm.getChargedNextBillingText = function () {
            const packageName = (vm.futurePlan && vm.futurePlan.name) || '';
            return $translate.instant('You will be charged the {{package}} package price as from next billing period.', { package: packageName });
        };

        function init() {

            vm.upgrading = vm.subscribed && (vm.currentPlan.amount < vm.futurePlan.amount);

            // Translate strings for nested ternary expressions
            if (vm.subscribed) {
                vm.actionText = vm.upgrading ? $translate.instant('upgrade') : $translate.instant('downgrade');
                vm.actionButtonText = vm.upgrading ? $translate.instant('Upgrade') : $translate.instant('Downgrade');
            }
            else {
                vm.actionText = $translate.instant('subscribe');
                vm.actionButtonText = $translate.instant('Subscribe');
            }
        }
    }
})();
